import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';

class RefreshTokenOttV2Task extends AbstractRequestTask {

    constructor(version = 'v2') {
        super();
        this.version = version;
        this.statusCode500As200 = true;
        this.statusCode401As200 = true;

      }
 
    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/v2/refresh_token`;
    }

    getHeaders() {
        const token = super.getParams().user_token
        return {
            Authorization: `Bearer ${token}`
        }
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.format;
        delete params.user_token;

        return { ...params };
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }

    isValid(data) {
        if (data.errors || !data.data || data.data === 'errors') {
            return false;
        }

        return true;
    }

    getStatusCode401As200(){
    return this.statusCode401As200;
    }

    getStatusCode500As200(){
    return this.statusCode500As200;
    }
}

export default RefreshTokenOttV2Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/v2/RefreshTokenOttV2Task.js